import { forwardRef } from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/cn';

export type SpinnerSize = 'xs' | 'sm' | 'md';

export interface SpinnerProps {
  size?: SpinnerSize;
  /**
   * Accessible name. Omit when the spinner sits next to visible loading text
   * (the common case) — it renders decorative (aria-hidden). Provide it when
   * the spinner is the ONLY loading indicator.
   */
  label?: string;
  className?: string;
}

const sizeClasses: Record<SpinnerSize, string> = {
  xs: 'h-3 w-3',
  sm: 'h-4 w-4',
  md: 'h-5 w-5',
};

/**
 * The one loading spinner — `Loader2` + `animate-spin` was re-rolled at four
 * call sites (and inside Button). Motion-reduce swaps the spin for a steady
 * glyph (the CSS squash already handles this, but be explicit).
 */
export const Spinner = forwardRef<SVGSVGElement, SpinnerProps>(function Spinner(
  { size = 'sm', label, className },
  ref,
) {
  return (
    <Loader2
      ref={ref}
      role={label ? 'status' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      className={cn('animate-spin motion-reduce:animate-none', sizeClasses[size], className)}
    />
  );
});
